import PropTypes from 'prop-types';

// material-ui
import { Typography } from '@mui/material';

import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material';
import React, { Children, useState } from 'react';

const StyledTooltip = styled(({ className, variant, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }} // ✅ attach styles to popper root
  />
))(({ variant }) => {
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      ...(variant === 'default' && {
        color: '#fff',
        backgroundColor: 'rgba(23, 43, 77, 0.7)',
        border: 'none',
        boxShadow: 'none',
        [`& .${tooltipClasses.arrow}`]: {
          color: 'rgba(23, 43, 77, 0.7)',
          border: 0,

          '&:before': {
            border: 'none',
            boxShadow: 'none',
          },
        },
      }),

      ...(variant === 'white' && {
        backgroundColor: '#FFF',
        color: '#000',
        [`& .${tooltipClasses.arrow}`]: {
          color: '#FFF',
          border: 0,
        },
      }),
    },
  };
});

const CustomTooltip = React.forwardRef((props, ref) => {
  const {
    disabled = false,
    title = '',
    children,
    disableHoverListener = true,
    showClose = false,
    variant = 'default',
    ...restProps
  } = props;
  if (disabled) {
    return children;
  }

  return (
    <>
      <StyledTooltip
        {...restProps}
        disableFocusListener={false}
        disableHoverListener={disableHoverListener}
        disableTouchListener={false}
        variant={variant}
        title={title}
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: ({ placement }) => {
                  const [base, align] = placement.split('-');
                  const distance = 0;
                  const cornerOffset = 15;

                  if (!align) return [0, distance]; // ← no suffix = centered, no offset

                  if (base === 'top' || base === 'bottom') {
                    if (align === 'start') return [-cornerOffset, distance];
                    if (align === 'end') return [cornerOffset, distance];
                  }

                  if (base === 'left' || base === 'right') {
                    if (align === 'start') return [0, cornerOffset];
                    if (align === 'end') return [0, -cornerOffset];
                  }

                  return [0, 0];
                },
              },
            },
          ],
        }}
      >
        {children}
      </StyledTooltip>
    </>
  );
});

export default CustomTooltip;
